import { render } from "./create-account-form.vue?vue&type=template&id=10db38bf"
import script from "./create-account-form.vue?vue&type=script&lang=js"
export * from "./create-account-form.vue?vue&type=script&lang=js"

import "./create-account-form.vue?vue&type=style&index=0&id=10db38bf&lang=scss"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__